// interprets a path for a property and returns the value if it exists
// *path is designated by app server
export const getPropByPath = (obj, path) => {
  if (typeof path !== 'string') {
    throw new TypeError('Path is not a valid string');
  }
  // convert any array indices to properties
  let propPath = path.replace(/\[(\w+)\]/g, '.$1');
  // strip leading dot
  propPath = propPath.replace(/^\./, '');
  // store each property in array
  const pathParts = propPath.split('.');

  // create copy of parameter to avoid undefined errors
  let objToSearch = Object.assign({}, obj);
  // for each property in array
  for (let i = 0; i < pathParts.length; i++) {
    const propName = pathParts[i];
    // if property exists in object
    if (objToSearch && propName in objToSearch) {
      // get value from current object and update curr obj
      objToSearch = objToSearch[propName];
    } else {
      return null;
    }
  }
  return objToSearch;
};

export const normalizePropertyPath = path => {
  // handle .properties
  const pathParts = path.split('.');
  return pathParts
    .map(
      input =>
        typeof input === 'string'
          ? input.charAt(0).toLowerCase() + input.slice(1)
          : input
    )
    .join('.');
};

const setProp = (currObj, value, prop, ...propPath) => {
  if (prop.search(/\[(\w+)\]/g) >= 0) {
    const arrIndex = parseInt(prop.replace(/\[(\w+)\]/g, '$1'), 10);
    const arrClone = [];
    const arrLength = Math.max((currObj || []).length, arrIndex + 1);
    for (let i = 0; i < arrLength; i++) {
      // eslint-disable-next-line eqeqeq
      if (i != arrIndex) {
        // todo: handle undefined
        arrClone[i] = currObj[i];
      } else {
        arrClone[i] = propPath.length
          ? setProp((currObj || arrClone)[i], value, ...propPath)
          : value;
      }
    }
    return arrClone;
  }

  // determine default value based on path
  const getDefault = path => {
    if (path.search(/\[(\w+)\]/g) >= 0) {
      const bracketContents = path.slice(1, path.length - 1);
      if (!isNaN(bracketContents)) {
        return [];
      }
    }
    return {};
  };

  if (Array.isArray(currObj)) {
    const arrClone = [];
    arrClone[prop] = propPath.length
      ? setProp(currObj[prop] || getDefault(propPath[0]), value, ...propPath)
      : value;
    return arrClone;
  }

  // return copy so no fields are lost
  return Object.assign({}, currObj, {
    [prop]: propPath.length
      ? setProp(
          (currObj || {})[prop] || getDefault(propPath[0]),
          value,
          ...propPath
        )
      : value,
  });
};

export const setPropByPath = (obj, path, value) => {
  // convert any array indices to properties
  let propPath = path.replace(/\[(\w+)\]/g, '.[$1]');
  // strip leading dot
  propPath = propPath.replace(/^\./, '');
  // store each property in array
  const pathParts = propPath.split('.');
  return Object.assign({}, obj, setProp(obj, value, ...pathParts));
};



// WEBPACK FOOTER //
// ./src/common/utils/property-path/index.js